import React, { useEffect } from 'react';
import { Form, Row, Col, Alert } from 'react-bootstrap';
import { calculateAge, isEmpty } from '../../../utilities/common';

export default function DemographicForm({
  formData,
  setFormData,
  formErrors,
  showFormErrors
}) {
  // const { eligibility } = formData;
  const handleChange = e => {
    const { name, value } = e.target;
    let updatedData = { ...formData, [name]: value };

    // If the user changes their date of birth, calculate and store age
    if (name === 'date_of_birth' && value) {
      const age = calculateAge(value);
      updatedData = { ...updatedData, age };
    }

    setFormData(updatedData);
  };

  const formatPhone = e => {
    const digits = e.target.value.replace(/\D/g, '');
    // Match NANP: optional leading 1, then area & exchange both 2–9 start, + 4 final digits
    const match = digits.match(/^1?([2-9]\d{2})([2-9]\d{2})(\d{4})$/);
    if (match) {
      setFormData({
        ...formData,
        phone: `(${match[1]}) ${match[2]}-${match[3]}`
      });
    }
  };

  console.log(formData);
  return (
    <div className="demographic-form">
      <h2>Your Information</h2>

      <Row className="mb-3">
        <Form.Group as={Col}>
          <Form.Label className="required">First Name</Form.Label>
          {!isEmpty(formErrors?.name_first) && (
            <span className="error-field">Required field</span>
          )}
          <Form.Control
            required
            type="text"
            name="name_first"
            maxLength={20}
            value={formData.name_first}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label className="required">Last Name</Form.Label>
          {!isEmpty(formErrors?.name_last) && (
            <span className="error-field">Required field</span>
          )}
          <Form.Control
            required
            type="text"
            name="name_last"
            maxLength={20}
            value={formData.name_last}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      <Form.Group className="mb-3">
        <Form.Label>Chosen Name</Form.Label>
        <Form.Control
          type="text"
          name="chosen_name"
          value={formData.chosen_name}
          onChange={handleChange}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Phone</Form.Label>
        {!isEmpty(formErrors?.phone) && (
          <span className="error-field">Required field</span>
        )}
        <Form.Control
          required
          type="tel"
          name="phone"
          inputMode="tel"
          value={formData.phone}
          onChange={handleChange}
          onBlur={formatPhone}
          pattern="^[+()0-9\\s-]+$"
          onKeyPress={e => /[\d()+\s-]/.test(e.key) || e.preventDefault()}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Email</Form.Label>
        <Form.Control
          required
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          isInvalid={
            showFormErrors &&
            !formData?.email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
          }
        />
        <Form.Control.Feedback type="invalid">
          Please enter a valid email address.
        </Form.Control.Feedback>
      </Form.Group>
      {/* {(formData.interest == 'Learn More' ||
        formData.fertility_treatment == 'Other') && (
        <Form.Group className="mb-3">
          <Form.Label className="required">Date of Birth</Form.Label>
          <Form.Control
            required
            type="date"
            name="date_of_birth"
            value={formData.date_of_birth}
            onChange={handleChange}
          />
        </Form.Group>
      )} */}

      <Form.Group className="mb-3">
        <Form.Label className="required">Sex Assigned at Birth</Form.Label>
        <Form.Select
          required
          name="sex_assigned_at_birth"
          value={formData.sex_assigned_at_birth}
          onChange={handleChange}
        >
          <option value="">Select...</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
          <option value="Other">Other</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label className="required">Gender Identity</Form.Label>
        <Form.Select
          required
          name="current_gender_identity"
          value={formData.current_gender_identity}
          onChange={handleChange}
        >
          <option value="">Select...</option>
          <option value="Woman">Woman</option>
          <option value="Trans Woman">Trans Woman</option>
          <option value="Man">Man</option>
          <option value="Trans Man">Trans Man</option>
          <option value="Non-binary">Non-binary</option>
          <option value="Not listed or prefer not to say">
            Not listed or prefer not to say
          </option>
        </Form.Select>
      </Form.Group>
      {formData.treatment_interest === 'not_sure' && (
        <Form.Group className="mb-3">
          <Form.Label className="required">
            Do you currently have an Ontario Health Insurance Plan (OHIP) card?
          </Form.Label>
          <div>
            <Form.Check
              required
              inline
              id={'valid_ohip-yes'}
              valid_ohip
              type="radio"
              label="Yes"
              name="valid_ohip"
              value="Yes"
              checked={formData.valid_ohip === 'Yes'}
              onChange={handleChange}
            />
            <Form.Check
              required
              inline
              id={'valid_ohip-no'}
              type="radio"
              label="No"
              name="valid_ohip"
              value="No"
              checked={formData.valid_ohip === 'No'}
              onChange={handleChange}
            />
          </div>
        </Form.Group>
      )}

      <Form.Group className="mb-3">
        <Form.Label className="required">
          Do you have a partner who will be involved in your treatment?
        </Form.Label>
        <div>
          <Form.Check
            required
            id={'partner_yes_no-yes'}
            inline
            type="radio"
            label="Yes"
            name="partner_yes_no"
            value="Yes"
            checked={formData.partner_yes_no === 'Yes'}
            onChange={handleChange}
          />
          <Form.Check
            required
            id={'partner_yes_no-no'}
            inline
            type="radio"
            label="No"
            name="partner_yes_no"
            value="No"
            checked={formData.partner_yes_no === 'No'}
            onChange={handleChange}
          />
        </div>
      </Form.Group>
    </div>
  );
}
